module.exports = __webpack_public_path__ + "img/icon-qrcode-border-br.b6f0ff59.svg";